var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"label":_vm.getCheckboxText(_vm.poiAddedToTour),"value":_vm.poiAddedToTour},model:{value:(_vm.poiAddedToTour),callback:function ($$v) {_vm.poiAddedToTour=$$v},expression:"poiAddedToTour"}})}
var staticRenderFns = []

export { render, staticRenderFns }